import { z } from "zod";
/** Kill-switch responses use a short TTL so enablement is not masked by long CDN/browser cache. */
export const KILL_SWITCH_CACHE_MAX_AGE_SECONDS = 5;
/**
 * Maximum time a client may still serve *pre-kill* public content after enablement,
 * given the previous Cache-Control of `max-age=60, stale-while-revalidate=30`.
 * New kill-switch responses do not use stale-while-revalidate.
 */
export const KILL_SWITCH_MAX_PROPAGATION_SECONDS = 90;
export const EMERGENCY_MAX_TTL_MS = 24 * 60 * 60 * 1000;
export const EMERGENCY_AUDIENCES = ["organization", "platform"];
export const KILL_SWITCH_SETTINGS_KEY = "remote_content.kill_switch";
export const killSwitchStateSchema = z.object({
    enabled: z.boolean(),
    reason: z.string().max(500).nullable(),
    enabledAt: z.string().datetime().nullable(),
    enabledByUserId: z.string().nullable(),
    expiresAt: z.string().datetime().nullable(),
});
export const enableKillSwitchSchema = z.object({
    password: z.string().min(1).max(128),
    reason: z.string().max(500).optional(),
    expiresAt: z.string().datetime().nullable().optional(),
});
export const disableKillSwitchSchema = z.object({
    password: z.string().min(1).max(128),
});
/** Validate emergency schedule: endsAt required, window ≤ 24h from effective start. */
export function validateEmergencySchedule(startsAt, endsAt, now = new Date()) {
    if (!endsAt) {
        return { ok: false, error: "Emergency announcements require endsAt within 24 hours" };
    }
    const effectiveStart = startsAt && startsAt.getTime() > now.getTime() ? startsAt : now;
    if (endsAt.getTime() <= effectiveStart.getTime()) {
        return { ok: false, error: "Emergency endsAt must be after the effective start" };
    }
    if (endsAt.getTime() - effectiveStart.getTime() > EMERGENCY_MAX_TTL_MS) {
        return {
            ok: false,
            error: "Emergency TTL must be 24 hours or less",
        };
    }
    return { ok: true };
}
//# sourceMappingURL=emergency.js.map